var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgALetterMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aLetMobile",
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.3079V34.03H23.4133V29.6758C21.5088 32.6213 17.8266 34.2861 12.7478 34.2861C5.38355 34.2861 0.812622 30.3161 0.812622 24.6812C0.812622 19.4305 4.11385 15.2044 13.7636 15.2044H23.0324V14.0518C23.0324 9.05723 20.1121 6.23979 14.3984 6.23979C10.5893 6.23979 6.65325 7.64851 4.11385 9.69755L1.70141 5.21526C5.00264 2.52589 9.82751 0.989105 15.0333 0.989105C24.0482 1.11717 29 5.4714 29 14.3079ZM23.1594 24.0409V19.4305H14.1445C8.30387 19.4305 6.65325 21.7357 6.65325 24.4251C6.65325 27.6267 9.31963 29.6758 13.7636 29.6758C18.2075 29.8038 21.7627 27.8828 23.1594 24.0409Z",
    fill: "#FF6060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgALetterMobile);
export default __webpack_public_path__ + "static/media/aLetterMobile.8d3840414e589c5015b454056613c3cf.svg";
export { ForwardRef as ReactComponent };